export default __webpack_public_path__ + "static/media/CRMMobile.ccf399ee.png";